import { useTranslation } from 'react-i18next';
import { Icon } from '../header/draft/Icon';
import { useOpenApp } from '../../hooks/useOpenApp';

type OpenAppBtnProps = {
  variant?: 'default' | 'login';
};

export default function OpenAppBtn({ variant = 'default' }: OpenAppBtnProps) {
  const { t } = useTranslation();
  const onClickOpenApp = useOpenApp();

  if (variant === 'login') {
    return (
      <button type="button" onClick={onClickOpenApp} className="login-open-app-btn">
        <Icon name="smartphone" className="login-open-app-btn__icon" />
        <span>{t('web.openApp')}</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClickOpenApp}
      className="h-[40px] w-fit rounded-full bg-N8 px-2 text-base font-medium text-[#F4F4F4]"
    >
      {t('web.openApp')}
    </button>
  );
}
